export default function PHP_ReferenceMySQLi() {
  return (
    <div>
      <h1>PHP_ReferenceMySQLi</h1>
    </div>
  );
}
